import { BrowserMultiFormatReader } from '@zxing/browser';
import type { IScannerControls } from '@zxing/browser';

export class QRCameraScanner {
  private reader = new BrowserMultiFormatReader();
  private controls: IScannerControls | null = null;

  async start(videoEl: HTMLVideoElement, onText: (text: string) => void): Promise<void> {
    this.controls = await this.reader.decodeFromVideoDevice(
      undefined, // use default camera selection (browser picks)
      videoEl,
      (result) => {
        if (result) {
          onText(result.getText());
        }
      },
    );
  }

  stop(): void {
    this.controls?.stop();
    this.controls = null;
  }
}
